import Router from '@utils/router'

new Router([
    {
        file: 'pages/main'
    },
    {
        file: 'pages/listing',
        resolve: '.listing-container'
    },
    {
        file: 'blocks/team',
        resolve: '.team'
    },
    {
        file: 'blocks/offers',
        resolve: '.offers'
    },
    {
        file: 'blocks/words',
        resolve: '.mea-anim'
    },
    {
        file: 'blocks/filters',
        resolve: '#filters'
    },
    {
        file: 'blocks/testimonials.js',
        resolve: '.testimonials'
    },
    {
        file: 'components/highlight',
        resolve: '.highlight'
    },
    {
        file: 'components/shuffled',
        resolve: '.infos-secur'
    },
    {
        file: 'blocks/faq',
        resolve: '.faq'
    }
]).load()